<template>
  <div
    class="control-user"
    @mouseenter="showDropdownUser"
    @mouseleave="hideDropdownUser"
  >
    <div class="icon" @click="iconClick">
      <f-sprite-icon :icon-link="$options.icons.IconUser" />
      <ui-badge
        v-if="LOGGED_IN"
        class="control-user__badge"
        :text="bonusesWithText"
        color="#95D4E9"
        :max-width="dropDownVisible ? '200' : '50'"
      />
    </div>
    <div class="dropdown">
      <ui-dropdown
        :visible="dropDownVisible"
        overlay-height="40"
        right
        @on-close="dropDownVisible = false"
      >
        <ul class="control-user-account">
          <li><a href="/account">Профиль<span>{{ ACCOUNT.firstName }}</span></a></li>
          <li><a href="/account/orders">Заказы</a></li>
          <li><a href="/account/addresses">Адреса</a></li>
          <li><a href="/account/subscribes">Подписки</a></li>
          <li><a href="/account/club">Клубная программа<ui-badge :text="bonusesWithText" size="large" color="#95D4E9" max-width="100" /></a></li>
          <li><a href="javascript:" @click="onClickLogout">Выход<f-sprite-icon :icon-link="$options.icons.IconExit" /></a></li>
        </ul>
      </ui-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { useLogout } from '@/composables/useLogout';

/* Icons */
import IconExit from '../../assets/icons/exit.svg';
import IconUser from '../../assets/icons/user.svg';

export default {
  name: 'control-user',
  icons: {
    IconUser,
    IconExit,
  },

  inject: ['adaptive'],

  setup() {
    const { logoutAccount } = useLogout();

    const onClickLogout = (e) => {
      e.preventDefault();
      logoutAccount();
    };

    return {
      onClickLogout,
    };
  },

  data: () => ({
    dropDownVisible: false,
    modalVisible: false,
  }),

  computed: {
    ...mapGetters({
      LOGGED_IN: 'user/loggedIn',
      ACCOUNT: 'user/account',
      BONUSES: 'user/bonuses',
    }),

    bonuses() {
      return `${this.$filters.price(this.BONUSES)}`;
    },

    bonusesWithText() {
      return `${this.bonuses} ${this.$filters.decl(this.BONUSES, 'бонус', ['', 'а', 'ов'])}`;
    },

    isDropdownAvailable() {
      return this.adaptive.isDesktop && this.LOGGED_IN;
    },
  },

  mounted() {
    this.$auth.emmiter.on('login', () => {
      this.modalVisible = false;
    });
  },

  methods: {
    iconClick() {
      const loggedIn = this.LOGGED_IN;

      this.$auth.login().then(({ loginProcessSucceed } = {}) => {
        if (!loggedIn && this.adaptive.isDesktop) return;

        // не открывать боковое меню сразу после авторизации
        if (loginProcessSucceed) return;

        if (this.adaptive.isDesktop) {
          this.toAccount();
        } else {
          this.$nav.show('account');
        }
      }).catch(() => {});
    },

    toAccount() {
      location = '/account';
    },

    showDropdownUser() {
      if (this.isDropdownAvailable) this.dropDownVisible = true;
    },

    hideDropdownUser() {
      if (this.isDropdownAvailable) this.dropDownVisible = false;
    },
  },
};
</script>

<style lang="scss">
.control-user {
  display: flex;
  flex-wrap: wrap;
}

@include breakpoint("desktop") {
  .control-user {
    .ui-dropdown {
      top: 40px;
      width: 280px;
    }

    &-account {
      list-style: none;
      margin: 8px 0;
      line-height: 24px;
      font-size: 14px;
      color: $black;

      li {
        a {
          display: flex;
          padding: 8px 12px;
          &:hover {
            background: $gray_bgr;
          }
          span {
            color: $gray;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            padding-left: 16px;
          }

          // TODO: Исправить на использование БЭМ-селекторов
          // stylelint-disable-next-line selector-max-universal
          > *:last-child {
            margin-left: auto;
          }
        }
        &:last-child {
          // ВЫХОД
          border-top: 1px solid $gray_lu;
          .sprite-icon {
            color: $gray;
            width: 20px;
            height: 20px;
          }
        }
      }
    }

    &__badge {
      @include stacking('infront', 1);
    }
  }
}
</style>
